import React from 'react';

import { observer } from 'mobx-react';

import { StripePaymentForm } from '../../../components/checkout/StripePaymentForm/StripePaymentForm';
import { TermsLinks } from '../../../../shared/components/TermsLinks/TermsLinks';
import { challengeCheckoutStore } from '../../../stores/challengeCheckoutStore';
import { SOLUTION_TYPE } from '../../../../shared/constants/user-info/solutionType';
import { generatePaymentResultUrl } from '../../../utils/generatePaymentResultUrl/generatePaymentResultUrl';
import { getRouteParam } from '../../../../shared/utils/angularUtils';
import {
  checkoutQueryParams,
  paymentResultQueryParams,
} from '../../../constants/pathQueryParams';
import { CHALLENGE_PAYMENT_RESULT_TYPE } from '../../../constants/challengePaymentResultType';

const CheckoutForm = observer(() => {
  const retryPath = getRouteParam(checkoutQueryParams.retryPath);
  const participantId = getRouteParam(checkoutQueryParams.participantId);

  const { challengeCheckoutInfo } = challengeCheckoutStore;

  if (!challengeCheckoutInfo) {
    return null;
  }

  const { checkoutDetails, paymentIntent, challenge } = challengeCheckoutInfo;

  const returnUrl = generatePaymentResultUrl(SOLUTION_TYPE.CHALLENGE, {
    [paymentResultQueryParams.retryPath]: retryPath,
    [paymentResultQueryParams.connectedAccountId]: paymentIntent.connectedAccountId,
    [paymentResultQueryParams.paymentIntentId]: paymentIntent.paymentIntentId || '',
    [paymentResultQueryParams.participantId]: participantId,
    [paymentResultQueryParams.paymentResultType]:
      CHALLENGE_PAYMENT_RESULT_TYPE.WITH_PAYMENT,
  });

  const paymentButtonProps = {
    returnUrl,
    label: challenge.challengeName,
    totalAmount: checkoutDetails.totalAmount,
    clientSecret: paymentIntent.clientSecret,
  };

  return (
    <StripePaymentForm paymentButtonProps={paymentButtonProps}>
      <TermsLinks />
    </StripePaymentForm>
  );
});

export { CheckoutForm };
